import Navbar from '@/pages/home/components/Navbar';
import Footer from '@/pages/home/components/Footer';
import Hero from './components/Hero';
import Openings from './components/Openings';

export default function CareersPage() {
  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      <Hero />
      <Openings />
      <Footer />
    </div>
  );
}